import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { compose } from 'recompose'

import { Modal } from 'containers/misc'
import { Form } from 'components/layout'
import { FormButton, Button } from 'components/misc'
import { AwardFileInfo } from 'components/sections/awards'
import { form } from 'helpers/decorators'
import { apiCodeLists } from 'helpers/decorators/api'
import { uploadFileValidation } from 'models/awards'
import { SUPPORTED_FILE_TYPES } from 'constants/enums'
import { AWARD_FILE_CATEGORY_TYPES, ACTIVITY_SECTIONS } from '../../../../constants/enums'
import { FormattedMessage } from 'react-intl'
import appConfig from 'config'


const enhance = compose(
  apiCodeLists(['activitySections', 'awardFileCategories']),
  form({
    form: 'award-file-upload',
    validate: uploadFileValidation
  })
)

class AwardFileUpload extends Component {
  static propTypes = {
    modalId: PropTypes.string.isRequired,
    loading: PropTypes.bool,
    submitting: PropTypes.bool,
    isJourney: PropTypes.bool,
    values: PropTypes.object,
    codeLists: PropTypes.object.isRequired,
    uploadAwardFiles: PropTypes.func.isRequired,
    cancelUpload: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    isContainParentalConsent: PropTypes.bool.isRequired,
    initialize: PropTypes.func.isRequired
  }
  static defaultProps = {}

  state = {
    file: null,
    fileSize: 0
  }

  fileSelection = e => {
    const file = e.target.files[0]

    this.props.change('file', file)
    this.setState({ fileSize: file.size })
  }

  mapFields = data => {
    const category = get(data, 'category.value')

    if (category === AWARD_FILE_CATEGORY_TYPES.residentialProject.id) {
      data.section = { value: ACTIVITY_SECTIONS.rp.id }
    }
    if (category === AWARD_FILE_CATEGORY_TYPES.adventureJourney.id) {
      data.section = { value: ACTIVITY_SECTIONS.aj.id }
    }
    if (category === AWARD_FILE_CATEGORY_TYPES.other.id || category === AWARD_FILE_CATEGORY_TYPES.parentalConsent.id) {
      data.section = null
    }

    return data
  }

  handleUploadAwardFile = fields => {
    return this.props.uploadAwardFiles(fields).then(() => {
      this.props.reset()
      this.setState({ fileSize: 0 })
    })
  }


  handleIsFileValid = () => {
    return this.state.fileSize > appConfig.fileSizeLimit
  }

  render() {
    const {
      handleSubmit,
      values,
      loading,
      codeLists,
      isJourney,
      initialize,
      submitting,
      modalId,
      isContainParentalConsent
    } = this.props

    return (
      <Modal id={modalId} customActions enableOverflow>
        <Form
          onSubmit={handleSubmit(this.handleUploadAwardFile)}
          loading={loading}
        >
          <AwardFileInfo initialize={initialize} codeLists={codeLists} isJourney={isJourney} isContainParentalConsent={isContainParentalConsent} />
          <div className="base-margin">
            <input
              type="file"
              onChange={this.fileSelection}
              accept={SUPPORTED_FILE_TYPES}
            /> <br />
            {this.handleIsFileValid() && (
               <span style={{ color: '#B71C1C', paddingRight: '30px', fontSize: '14px' }}>
                <FormattedMessage
                    id="errors.file_is_too_large"
                    defaultMessage="File is too large."
                />
              </span>)}

          </div>
          <div className="row">
            <div className="col-xs-6">
              {this.props.cancelUpload &&
                <Button
                  type="button"
                  secondary
                  intlKey="button.close"
                  onClick={this.props.cancelUpload}
                >
                  Close
                </Button>}
            </div>
            <div className="col-xs-6 text--right">
              <FormButton
                {...this.props}
                intlKey="button.upload"
                isLoading={submitting}
                disabled={!get(values, 'file') || loading || this.handleIsFileValid()}
                invalid={this.handleIsFileValid()}
              >
                Upload
              </FormButton>
            </div>
          </div>
        </Form>
      </Modal>
    )
  }
}

export default enhance(AwardFileUpload)
